import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer website design services in Rajkot?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide complete website design, development, SEO, and e-commerce solutions for businesses in Rajkot."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of designing a website in Rajkot?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Basic websites start from ₹10,000. The cost varies based on the number of pages, design complexity, and extra features like forms or e-commerce functionality."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all our websites are mobile-friendly and optimized for tablets and desktops to ensure smooth user experience across devices."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included with website development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we follow SEO best practices including fast load speed, meta tags, schema markup, mobile optimization, and clean URLs."
      }
    },
    {
      "@type": "Question",
      "name": "Can I edit the website content myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we use WordPress and similar CMS platforms that allow you to update your content, images, and blogs easily without coding."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build e-commerce websites in Rajkot?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we create secure e-commerce websites with shopping carts, payment gateways, product filters, and admin dashboards."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Standard websites are usually delivered within 2–4 weeks. E-commerce or custom projects may take longer based on complexity."
      }
    },
    {
      "@type": "Question",
      "name": "Do you assist with domain and hosting?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help you register your domain, set up web hosting, configure SSL, and connect everything properly to launch your site."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer ongoing website maintenance in Rajkot?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer maintenance packages that include regular updates, backups, uptime monitoring, and content support."
      }
    },
    {
      "@type": "Question",
      "name": "How can I get started with web design in Rajkot?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Just contact us through our website or phone. We’ll discuss your needs, suggest the best plan, and begin the development process."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Rajkot</title>
<meta name="description" content="Top website designer in Rajkot. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="website development company in rajkot, web development company in rajkot, rajkot web design company, website design company in rajkot, website developer in rajkot, website design in rajkot, website development in rajkot, website designer in rajkot, website designer rajkot, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Rajkot" />
<meta property="og:description" content="Top Website Designer In Rajkot. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Rajkot" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-rajkot"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Rajkot" />
<meta name="twitter:description" content="Top website designer in Rajkot. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-rajkot" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Rajkot</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Rajkot</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Are you looking for a skilled and innovative website designer in Rajkot? Your search ends here! I’m Pankaj, a passionate website designer dedicated to creating eye-catching and highly functional websites that help you establish a strong online presence and grow your business.
<h3>Why Choose Pankaj for Your Website Design?</h3>
<ol>
  <li><strong>Custom Designs That Capture Your Brand Essence</strong>
With years of experience in the industry, I specialize in crafting tailored website solutions that reflect your brand's unique identity. Whether you need a professional corporate website, a dynamic e-commerce platform, or a personal blog, I ensure that your site not only looks stunning but also serves its intended purpose.</li>
  <li><strong>SEO-Optimized Websites for Enhanced Online Visibility</strong>
A beautiful website is only effective if it can be discovered. I implement essential SEO practices in all my designs, helping your website rank higher on search engines like Google. This increases visibility, attracting more visitors and potential customers to your site.</li>
  <li><strong>Comprehensive Website Design Services</strong>
I offer a full range of services, including website development, redesigns, and e-commerce solutions. My expertise with popular CMS platforms like WordPress allows you to easily manage your content post-launch.</li>
  <li><strong>Transparent Pricing and Ongoing Support</strong>
I believe in clear communication and transparent pricing. After discussing your project requirements, I provide a detailed quote so there are no surprises. My commitment to client satisfaction means I’m here to support you even after your website goes live.</li>
</ol>
<h3>Services Offered</h3>
<ul>
  <li><strong>Custom Website Design &amp; Redesign</strong>
Unique, modern designs tailored to your brand identity, enhancing user engagement and providing a positive user experience.</li>
  <li><strong>E-commerce Website Development</strong>
Secure and user-friendly e-commerce platforms designed to optimize conversions and provide a seamless shopping experience for your customers.</li>
  <li><strong>Corporate and Personal Websites</strong>
Professionally designed websites that effectively showcase your business or personal projects, engaging visitors and clearly conveying your goals.</li>
  <li><strong>SEO and Digital Marketing Services</strong>
Basic SEO practices included in all designs, with options for advanced strategies through collaboration with trusted marketing partners.</li>
</ul>
<h3>Get Started Today</h3>
Ready to take your online presence to the next level? Contact me today to discuss your vision, and let’s collaborate to create a website that truly represents your brand in the digital landscape.
<h2>Frequently Asked Questions</h2>

<h4>What types of websites can Pankaj design in Rajkot?</h4>
<p>Pankaj specializes in designing a variety of websites, including corporate sites, e-commerce platforms, personal blogs, and portfolios. Each website is tailored to meet the specific needs and goals of the client.</p>

<h4>Why should I choose Pankaj as my website designer?</h4>
<p>Pankaj offers high-quality, responsive, and SEO-friendly websites crafted with attention to detail. His extensive experience ensures that each project effectively communicates your brand identity while providing a seamless user experience.</p>

<h4>Does Pankaj provide SEO services for my website?</h4>
<p>Yes, Pankaj incorporates basic SEO practices in all his website designs to enhance visibility on search engines. For more advanced SEO strategies, he can collaborate with trusted partners who specialize in digital marketing.</p>

<h4>How much does it cost to design a website with Pankaj?</h4>
<p>The cost of designing a website depends on several factors, including the project's complexity, the number of pages, and any additional features you may want. Pankaj provides project-specific quotes after discussing your requirements and budget.</p>

<h4>Can I update my website content after it’s launched?</h4>
<p>Absolutely! Pankaj builds websites using user-friendly CMS platforms like WordPress, allowing you to easily manage and update your content once the site is live. He also provides training and documentation to help you navigate updates.</p>

<h4>What if I need help with my website after it’s live?</h4>
<p>Pankaj offers ongoing maintenance and support for all his clients. This includes troubleshooting, updates, and performance improvements to ensure your website remains secure and effective over time.</p>

<h4>How long does it take to complete a website design project?</h4>
<p>The timeline for completing a website design project varies based on its complexity and specific requirements. After discussing your project, Pankaj will provide a realistic timeline, which typically ranges from a few weeks to a couple of months.</p>

<h4>How can I get in touch with Pankaj for my website design project?</h4>
<p>You can reach out to Pankaj through the contact form on this website or by using the provided contact information. He will be happy to discuss your project and help you create a website that meets your needs.</p>

          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
